// extracted by mini-css-extract-plugin
module.exports = {"text":"ArticleItemTeaserText_text__H_RS_"};